<script>
    // Licensed under Gnu Public Licence version 2
    // Copyright (c) 2023 (original work) Open Assessment Technologies SA ;

    /**
     * Dynamic heading component for H1-H6 tags
     * Also supports standard attributes such as class, style, data-*, aria-*
     * @property {Number} level
     */
    export let level = 1;
</script>

{#if level === 1}
    <h1 {...$$restProps}>
        <slot/>
    </h1>
{:else if level === 2}
    <h2 {...$$restProps}>
        <slot/>
    </h2>
{:else if level === 3}
    <h3 {...$$restProps}>
        <slot/>
    </h3>
{:else if level === 4}
    <h4 {...$$restProps}>
        <slot/>
    </h4>
{:else if level === 5}
    <h5 {...$$restProps}>
        <slot/>
    </h5>
{:else if level === 6}
    <h6 {...$$restProps}>
        <slot/>
    </h6>
{/if}
